import { Component, ComponentFactoryResolver, EventEmitter, Input, NgModuleRef, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ComponentData } from './component-data';
import { ModalNavigatorDirective } from './modal-navigator-anchor.directive';
import { IModalNavigator } from './modal-navigator.interface';
import { IMultiModalComponent } from './multi-modal-component.interface';

@Component({
  selector: 'app-modal-navigator',
  templateUrl: './modal-navigator.component.html',
})
export class ModalNavigatorComponent implements IModalNavigator {
  @ViewChild(ModalNavigatorDirective, { static: true }) public dynamicModalReference: ModalNavigatorDirective;
  @Input() public startComponent: IMultiModalComponent;

  public isFirstModal: boolean;
  public back$ = new EventEmitter();

  private componentHistory: ComponentData[];
  private previousInstance: any;

  constructor(private componentFactoryResolver: ComponentFactoryResolver, private activeModal: NgbActiveModal) {
    this.componentHistory = [];
    this.isFirstModal = false;
  }

  public initializeStartView(view: any, ngModuleRef?: NgModuleRef<any>): any {
    return this.goToView(view, ngModuleRef);
  }

  public goToView(view: any, ngModuleRef?: NgModuleRef<any>): any {
    const instance = this.setView(view, ngModuleRef);

    const lastHistoryItemIndex: number = this.componentHistory.length - 1;
    const lastHistoryItem: ComponentData = this.componentHistory[lastHistoryItemIndex];

    if (lastHistoryItem === undefined || view !== lastHistoryItem.classType) {
      this.componentHistory.push(new ComponentData(view, instance));
    }

    this.isFirstModal = this.componentHistory.length <= 1;
    this.previousInstance = undefined;
    instance.modalNavigator = this;

    return instance;
  }

  public goBack(returnNumberOfSteps: number = 1): IMultiModalComponent {
    if (this.componentHistory.length < returnNumberOfSteps + 1) {
      this.close();
      return;
    }

    this.componentHistory.splice(this.componentHistory.length - returnNumberOfSteps, returnNumberOfSteps);
    const history = this.componentHistory[this.componentHistory.length - 1];

    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(history.classType);

    const viewContainerRef = this.dynamicModalReference.viewContainerRef;
    viewContainerRef.clear();

    const instance = viewContainerRef.createComponent(componentFactory).instance as IMultiModalComponent;

    this.isFirstModal = this.componentHistory.length <= 1;

    this.previousInstance = history.componentInstance;

    instance.modalNavigator = this;

    this.back$.emit();

    return instance;
  }

  public close(): void {
    this.activeModal.close();
  }

  public getPreviousInstance(): any {
    return this.previousInstance;
  }

  public goToFirstView(): void {
    while (!this.isFirstModal) {
      this.goBack();
    }
  }

  private setView(view: any, ngModuleRef?: NgModuleRef<any>): IMultiModalComponent {
    const componentFactoryResolver = ngModuleRef?.componentFactoryResolver || this.componentFactoryResolver;
    const componentFactory = componentFactoryResolver.resolveComponentFactory(view);
    const viewContainerRef = this.dynamicModalReference.viewContainerRef;
    viewContainerRef.clear();

    return viewContainerRef.createComponent(componentFactory).instance as IMultiModalComponent;
  }
}
